/**
 * Dimensiones reales (px) de las imágenes de `src/assets`, leídas de los
 * archivos. Se usan para reservar espacio antes de que carguen las imágenes
 * y evitar saltos de maquetación, sin recortar ni deformar la evidencia.
 */
export const imageDimensions: Record<string, { w: number; h: number }> = {
  "/assets/blog/ai-marketing-strategy.jpg": { w: 1024, h: 576 },
  "/assets/blog/ai-prompts-guide.jpg": { w: 1024, h: 576 },
  "/assets/blog/amazon-competitor-analysis.jpg": { w: 1024, h: 576 },
  "/assets/blog/ecommerce-compliance.jpg": { w: 1024, h: 576 },
  "/assets/blog/fda-requirements.jpg": { w: 1024, h: 576 },
  "/assets/blog/google-ads-automation.jpg": { w: 1024, h: 576 },
  "/assets/blog/market-research-ai.jpg": { w: 1024, h: 576 },
  "/assets/blog/register-business-usa.jpg": { w: 1024, h: 576 },
  "/assets/blog/scalable-content-ai.jpg": { w: 1024, h: 576 },
  "/assets/blog/seo-predictive-ai.jpg": { w: 1024, h: 576 },
  "/assets/case-studies/amazon-abrasives-products.jpg": { w: 1024, h: 576 },
  "/assets/case-studies/amazon-ads-performance.png": { w: 1920, h: 640 },
  "/assets/case-studies/amazon-campaigns-roas.png": { w: 1920, h: 768 },
  "/assets/case-studies/amazon-international-sales.png": { w: 1920, h: 932 },
  "/assets/case-studies/amazon-sales-dashboard.png": { w: 1920, h: 993 },
  "/assets/case-studies/bms-avapro-signatures.png": { w: 1920, h: 1425 },
  "/assets/case-studies/bms-logo.webp": { w: 424, h: 213 },
  "/assets/case-studies/bms-pharma-technology.jpg": { w: 1024, h: 576 },
  "/assets/case-studies/bms-picot-packaging.png": { w: 1920, h: 1425 },
  "/assets/case-studies/bms-sicodi-products.png": { w: 1733, h: 1214 },
  "/assets/case-studies/bms-sicodi-users.png": { w: 2000, h: 1633 },
  "/assets/case-studies/el-nino-2bowl.jpg": { w: 864, h: 1165 },
  "/assets/case-studies/el-nino-3bowl.jpg": { w: 1080, h: 1103 },
  "/assets/case-studies/el-nino-beverages-display.jpg": { w: 1024, h: 576 },
  "/assets/case-studies/el-nino-branding.png": { w: 1380, h: 480 },
  "/assets/case-studies/el-nino-original.gif": { w: 265, h: 255 },
  "/assets/case-studies/venado-ecommerce.png": { w: 1920, h: 1677 },
  "/assets/case-studies/venado-empaque.png": { w: 1173, h: 1206 },
  "/assets/case-studies/venado-grocery-shelf.jpg": { w: 1024, h: 576 },
  "/assets/case-studies/venado-nuevo.png": { w: 1920, h: 1425 },
  "/assets/case-studies/venado-original.png": { w: 1920, h: 1425 },
  "/assets/case-studies/venado-packaging-crop.jpg": { w: 550, h: 420 },
  "/assets/case-studies/venado-products-crop.jpg": { w: 1205, h: 800 },
  "/assets/case-studies/venado-store-crop.jpg": { w: 1570, h: 870 },
  "/assets/client-satisfaction.jpg": { w: 1378, h: 954 },
  "/assets/experience-years.jpg": { w: 1024, h: 768 },
  "/assets/google-ads-dashboard-success.jpg": { w: 1200, h: 800 },
  "/assets/google-partner-badge.jpg": { w: 1920, h: 989 },
  "/assets/hero-banner-roc.jpg": { w: 1920, h: 1280 },
  "/assets/hispanic-business-success.jpg": { w: 1024, h: 768 },
  "/assets/llm-analytics-dashboard.jpg": { w: 800, h: 600 },
  "/assets/llm-chat-example.jpg": { w: 1024, h: 768 },
  "/assets/llm-positioning-hero.jpg": { w: 1920, h: 1080 },
  "/assets/luis-roc-about.jpg": { w: 1920, h: 1440 },
  "/assets/luis-roc-office.jpg": { w: 1920, h: 1440 },
  "/assets/luis-roc-profile.jpg": { w: 1090, h: 1090 },
  "/assets/luis-roc-seo-houston-hero.jpg": { w: 1200, h: 750 },
  "/assets/roi-growth.jpg": { w: 1920, h: 864 },
  "/assets/search-evolution.jpg": { w: 1024, h: 768 },
  "/assets/seo-audit-results.jpg": { w: 1024, h: 768 },
  "/assets/seo-backlink-analysis.jpg": { w: 1024, h: 768 },
  "/assets/seo-citations-data.jpg": { w: 1200, h: 800 },
  "/assets/seo-competitor-analysis.jpg": { w: 1024, h: 768 },
  "/assets/seo-consultation-form.jpg": { w: 1024, h: 768 },
  "/assets/seo-google-business.jpg": { w: 1200, h: 800 },
  "/assets/seo-keyword-metrics.jpg": { w: 1200, h: 800 },
  "/assets/seo-keyword-tracking.jpg": { w: 1200, h: 800 },
  "/assets/seo-listing-changes.jpg": { w: 1200, h: 800 },
  "/assets/seo-listing-details.jpg": { w: 1200, h: 800 },
  "/assets/seo-listing-score.jpg": { w: 1200, h: 800 },
  "/assets/seo-listing-sync.jpg": { w: 1200, h: 800 },
  "/assets/seo-local-grid.jpg": { w: 1200, h: 800 },
  "/assets/seo-methodology-diagram.jpg": { w: 800, h: 600 },
  "/assets/seo-onpage-analysis.jpg": { w: 1024, h: 768 },
  "/assets/seo-overview-dashboard.jpg": { w: 1200, h: 800 },
  "/assets/seo-reputation-analytics.jpg": { w: 1200, h: 800 },
  "/assets/seo-results-dashboard.jpg": { w: 1024, h: 768 },
  "/assets/seo-reviews-rating.jpg": { w: 1200, h: 800 },
  "/assets/seo-search-console.jpg": { w: 1200, h: 800 },
  "/assets/seo-technical-audit-dashboard.jpg": { w: 1024, h: 768 },
  "/assets/seo-tools-optimization.jpg": { w: 1024, h: 768 },
  "/assets/seo-vs-llm-comparison.jpg": { w: 1024, h: 768 },
  "/assets/seo-website-analytics.jpg": { w: 1200, h: 800 },
  "/assets/seo-website-performance.jpg": { w: 1200, h: 800 },
  "/assets/services/amazon-marketplace-hero.jpg": { w: 1024, h: 576 },
  "/assets/services/auto-insurance-dallas.jpg": { w: 1024, h: 576 },
  "/assets/services/beauty-products-sephora.jpg": { w: 1024, h: 576 },
  "/assets/services/construction-luxury.jpg": { w: 1024, h: 576 },
  "/assets/services/content-strategy-workspace.jpg": { w: 1024, h: 576 },
  "/assets/services/dental-clinic-sanantonio.jpg": { w: 1024, h: 576 },
  "/assets/services/fashion-ecommerce-miami.jpg": { w: 1024, h: 576 },
  "/assets/services/immigration-law-houston.jpg": { w: 1024, h: 576 },
  "/assets/services/law-firm-houston.jpg": { w: 1024, h: 576 },
  "/assets/services/restaurant-rebranding.jpg": { w: 1024, h: 576 },
  "/assets/services/saas-startup-dashboard.jpg": { w: 1024, h: 576 },
  "/assets/visual-lab/hero-arch-mobile.jpg": { w: 1100, h: 900 },
  "/assets/visual-lab/hero-arch.jpg": { w: 1920, h: 938 },
};

export const getImageDimensions = (key: string) => imageDimensions[key];
